import React, { memo } from "react";
import { LoanOptionButtonSmall } from "../../../atoms/buttons/LoanOptionButtonSmall";
import { styled } from "@mui/material";
import { ArmBoldIcon } from "../../../atoms/icons/arm-bold";
import { FixedBoldIcon } from "../../../atoms/icons/fixed-bold";

const ErrorNoLoan = styled("div")({
  color: "orange",
  fontSize: "12px",
  fontWeight: "bold",
  width: "100%",
  textAlign: "left",
  paddingTop: "10px",
});

const LoanOptionBlockSmallComponent = ({
  loanOptions,
  customFormEdit,
  showError = true,
}) => {
  return (
    <div className="loan-options-row-wrapper">
      <div>
        <div className="loan-options-fixed-wrapper">
          <div className="loan-option-type-wrapper-small">
            <div className="loan-option-type-icon">
              <FixedBoldIcon fill="white" width="24px" height="24px" />
            </div>
            <div className="loan-option-type-subtitle-small">Fixed</div>
          </div>
          <LoanOptionButtonSmall
            title="10"
            subtitle="year"
            selected={loanOptions && loanOptions?.includes("10Fixed")}
            onClick={() => {
              let newLoanOptions = [];
              if (Array.isArray(loanOptions)) {
                newLoanOptions = [...loanOptions];
              }
              if (loanOptions && loanOptions?.includes("10Fixed")) {
                newLoanOptions = newLoanOptions.filter(
                  (item) => item !== "10Fixed"
                );
              } else {
                newLoanOptions.push("10Fixed");
              }
              customFormEdit("loanOptions", newLoanOptions);
            }}
          />
          <LoanOptionButtonSmall
            title="15"
            subtitle="year"
            selected={loanOptions && loanOptions?.includes("15Fixed")}
            onClick={() => {
              let newLoanOptions = [];
              if (Array.isArray(loanOptions)) {
                newLoanOptions = [...loanOptions];
              }
              if (loanOptions && loanOptions?.includes("15Fixed")) {
                newLoanOptions = newLoanOptions.filter(
                  (item) => item !== "15Fixed"
                );
              } else {
                newLoanOptions.push("15Fixed");
              }
              customFormEdit("loanOptions", newLoanOptions);
            }}
          />
          <LoanOptionButtonSmall
            title="20"
            subtitle="year"
            selected={loanOptions && loanOptions?.includes("20Fixed")}
            onClick={() => {
              let newLoanOptions = [];
              if (Array.isArray(loanOptions)) {
                newLoanOptions = [...loanOptions];
              }
              if (loanOptions && loanOptions?.includes("20Fixed")) {
                newLoanOptions = newLoanOptions.filter(
                  (item) => item !== "20Fixed"
                );
              } else {
                newLoanOptions.push("20Fixed");
              }
              customFormEdit("loanOptions", newLoanOptions);
            }}
          />
          <LoanOptionButtonSmall
            title="30"
            subtitle="year"
            selected={loanOptions && loanOptions?.includes("30Fixed")}
            onClick={() => {
              let newLoanOptions = [];
              if (Array.isArray(loanOptions)) {
                newLoanOptions = [...loanOptions];
              }
              if (loanOptions && loanOptions?.includes("30Fixed")) {
                newLoanOptions = newLoanOptions.filter(
                  (item) => item !== "30Fixed"
                );
              } else {
                newLoanOptions.push("30Fixed");
              }
              customFormEdit("loanOptions", newLoanOptions);
            }}
          />
        </div>
        <div className="loan-options-arm-wrapper">
          <div className="loan-option-type-wrapper-small">
            <div className="loan-option-type-icon">
              <ArmBoldIcon fill="white" width="24px" height="24px" />
            </div>
            <div className="loan-option-type-subtitle-small">ARM</div>
          </div>
          <LoanOptionButtonSmall
            title="5/6"
            subtitle="ARM"
            selected={loanOptions && loanOptions?.includes("ARM56")}
            onClick={() => {
              let newLoanOptions = [];
              if (Array.isArray(loanOptions)) {
                newLoanOptions = [...loanOptions];
              }
              if (loanOptions && loanOptions?.includes("ARM56")) {
                newLoanOptions = newLoanOptions.filter(
                  (item) => item !== "ARM56"
                );
              } else {
                newLoanOptions.push("ARM56");
              }
              customFormEdit("loanOptions", newLoanOptions);
            }}
          />
          <LoanOptionButtonSmall
            title="7/6"
            subtitle="ARM"
            selected={loanOptions && loanOptions?.includes("ARM76")}
            onClick={() => {
              let newLoanOptions = [];
              if (Array.isArray(loanOptions)) {
                newLoanOptions = [...loanOptions];
              }
              if (loanOptions && loanOptions?.includes("ARM76")) {
                newLoanOptions = newLoanOptions.filter(
                  (item) => item !== "ARM76"
                );
              } else {
                newLoanOptions.push("ARM76");
              }
              customFormEdit("loanOptions", newLoanOptions);
            }}
          />
          <LoanOptionButtonSmall
            title="10/6"
            subtitle="ARM"
            selected={loanOptions && loanOptions?.includes("ARM106")}
            onClick={() => {
              let newLoanOptions = [];
              if (Array.isArray(loanOptions)) {
                newLoanOptions = [...loanOptions];
              }
              if (loanOptions && loanOptions?.includes("ARM106")) {
                newLoanOptions = newLoanOptions.filter(
                  (item) => item !== "ARM106"
                );
              } else {
                newLoanOptions.push("ARM106");
              }
              customFormEdit("loanOptions", newLoanOptions);
            }}
          />
        </div>
      </div>
      {!loanOptions?.length && showError && (
        <ErrorNoLoan>At least one type must be selected</ErrorNoLoan>
      )}
    </div>
  );
};

function arePropsEqual(prevProps, nextProps) {
  const {
    loanOptions: prevLoanOptions,
    customFormEdit: prevCustomFormEdit,
    showError: prevShowError,
  } = prevProps;
  const {
    loanOptions: nextLoanOptions,
    customFormEdit: nextCustomFormEdit,
    showError: nextShowError,
  } = nextProps;

  const isPrevCustomFormEditFalsey = !prevCustomFormEdit;
  const isNextCustomFormEditFalsey = !nextCustomFormEdit;

  const hasCustomFormEditChanged =
    isPrevCustomFormEditFalsey != isNextCustomFormEditFalsey;
  const hasLoanOptionsChanged = prevLoanOptions
    ? prevLoanOptions.length != nextLoanOptions.length
    : true;
  const hasShowErrorChanged = prevShowError != nextShowError;

  return (
    !hasCustomFormEditChanged && !hasLoanOptionsChanged && !hasShowErrorChanged
  );
}

export const LoanOptionBlockSmall = memo(
  LoanOptionBlockSmallComponent,
  arePropsEqual
);
